import React from 'react';

import { className } from 'aplazame-design-system';

import HeroSection from '../HeroSection';
import SocialIconsComponent from '../SocialIconsComponent';


export default function HeroAuthorSection({
    facebookUrl,
    twitterUrl,
    linkedinUrl,
    ...props
}) {
    return (
        <>
            <HeroSection
                {...props}
                textClassName="h4"
                extraContent={
                    facebookUrl || twitterUrl || linkedinUrl ? (
                        <SocialIconsComponent
                            wrapperClassName="mt-4 mb-4 mb-lg-0"
                            title={props.title}
                            facebookUrl={facebookUrl}
                            twitterUrl={twitterUrl}
                            linkedinUrl={linkedinUrl}
                        />
                    ) : null
                }
            />
            <div {...className('pt-10')} />
        </>
    );
}